export default __webpack_public_path__ + "ymca-info-icon.svg";